(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["camadas-slider"] && !Shopify.designMode) return;
  try {
    
  class CamadasSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-camadas-viewport]');
      this.slides = Array.from(this.querySelectorAll('[data-camadas-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-camadas-dot]'));
      this.prevButton = this.querySelector('[data-camadas-prev]');
      this.nextButton = this.querySelector('[data-camadas-next]');

      if (!this.viewport || this.slides.length === 0) return;

      this.activeIndex = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplayEnabled = this.hasAttribute('data-autoplay') && this.slides.length > 1 && !this.reducedMotion;
      this.autoplaySpeed = (parseFloat(this.getAttribute('data-autoplay-speed')) || 6) * 1000;
      this.autoplayTimer = null;

      this.slides[0].classList.add('is-active');

      this.setupObserver();
      this.bindDots();
      this.bindArrows();
      this.bindKeyboard();
      this.bindAutoplay();
      this.bindEditorEvents();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this.observer) this.observer.disconnect();
    }

    setupObserver() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const index = this.slides.indexOf(entry.target);
          if (index === -1) return;
          entry.target.classList.toggle('is-active', entry.isIntersecting && entry.intersectionRatio >= 0.6);
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            this.setActiveIndex(index);
          }
        });
      }, { root: this.viewport, threshold: [0.6] });

      this.slides.forEach((slide) => this.observer.observe(slide));
    }

    setActiveIndex(index) {
      this.activeIndex = index;
      this.dots.forEach((dot, dotIndex) => {
        dot.setAttribute('aria-selected', dotIndex === index ? 'true' : 'false');
      });
    }

    goToIndex(index) {
      const count = this.slides.length;
      const wrappedIndex = ((index % count) + count) % count;
      const target = this.slides[wrappedIndex];
      if (!target) return;
      // scrollIntoView({inline:'center'}) não é confiável junto de
      // scroll-snap-type mandatory (não move o scroll em alguns motores de
      // navegador). Calculamos a posição exata em vez de depender dele.
      const step = (this.viewport.scrollWidth - this.viewport.clientWidth) / Math.max(1, count - 1);
      this.viewport.scrollTo({
        left: Math.round(step * wrappedIndex),
        behavior: this.reducedMotion ? 'instant' : 'smooth'
      });
    }

    bindDots() {
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.goToIndex(index);
          this.restartAutoplay();
        });
      });
    }

    bindArrows() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.goToIndex(this.activeIndex - 1);
          this.restartAutoplay();
        });
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.goToIndex(this.activeIndex + 1);
          this.restartAutoplay();
        });
      }
    }

    bindKeyboard() {
      this.viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goToIndex(this.activeIndex + 1);
          this.restartAutoplay();
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goToIndex(this.activeIndex - 1);
          this.restartAutoplay();
        }
      });
    }

    bindAutoplay() {
      if (!this.autoplayEnabled) return;

      this.startAutoplay();

      ['pointerenter', 'focusin'].forEach((eventName) => {
        this.addEventListener(eventName, () => this.stopAutoplay());
      });

      ['pointerleave', 'focusout'].forEach((eventName) => {
        this.addEventListener(eventName, () => this.startAutoplay());
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      });
    }

    startAutoplay() {
      if (!this.autoplayEnabled || this.autoplayTimer) return;
      this.autoplayTimer = window.setInterval(() => {
        this.goToIndex((this.activeIndex + 1) % this.slides.length);
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    restartAutoplay() {
      if (!this.autoplayEnabled) return;
      this.stopAutoplay();
      this.startAutoplay();
    }

    bindEditorEvents() {
      if (!window.Shopify || !window.Shopify.designMode) return;

      document.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.indexOf(event.target);
        if (index !== -1) {
          this.stopAutoplay();
          this.goToIndex(index);
        }
      });
    }
  }

  if (!customElements.get('camadas-slider')) {
    customElements.define('camadas-slider', CamadasSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
